<div id="{{key}}" class="px-5 py-3 list-text-gadget" [ngClass]="!print ? 'download-hide' : 'd-print-block'">
  <check-to-print (notify)="onPrintNotify()" [key]="key"></check-to-print>
  <h3 translate>{{title}}</h3>
  @if (data && filters && filters.value && data[filters.value]) {
    <div class="mt-3">
      <div class="header d-flex fw-bold" >
        @for (label of labels; track label) {
          <div translate>{{label}}</div>
        }
      </div>
      @for (item of data[filters.value]; track item; let i = $index) {
        @if (i <= 4 && !open || open) {
          <div class="py-1 data-table d-flex" >
            <div>{{i + 1}}</div>
            @if (!link) {
              <div>{{item[1]}}</div>
            } @else {
              <div> <a [href]="item[1]" target="_blank">{{item[1]}}</a> </div>
            }
            <div>{{item[2]}}</div>
            <div>{{item[3]  | number : '1.0-2'}}%</div>
          </div>
        }
      }
      <div class="show_more_less">
        @if (!open && data[filters.value].length > 4) {
          <div type="button" class="" (click)="open=true" translate>Show More</div>
        }
        @if (open) {
          <div type="button" class=" " (click)="open=false" translate>Show Less</div>
        }
      </div>
    </div>
  } @else {
    @if (!loader) {
      NO DATA
    } @else {
      <contentloader></contentloader>
    }
  }
  <div class="page-break"> </div>
</div>


